import { Panel } from "rsuite";

import "./basicPanel.css";

export default function BasicPanel({ children, header, className, ...props }) {
    return (
        <Panel header={header} {...props} className={"basicPanel " + className}>
            {children}
        </Panel>
    )
}